import dynamic from 'next/dynamic'
import Translations from '@helpers/translations'
import { resizeShopifyImage } from '@helpers/shopify'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import styles from './styles.module.scss'

const Tabs = dynamic(() => import('@components/ui/Tabs'))
const Modal = dynamic(() => import('@components/ui/Modal'))

const TRUNKS_LEG_DATA = [
  {
    text: '3”',
    subTitle: '3” Trunks',
    description: '',
    img: {
      url: resizeShopifyImage(
        'https://cdn.shopify.com/s/files/1/0207/9406/files/trunks_three_inches_leg.jpg?v=1698066618',
        { width: '600' }
      ),
      width: 300,
      height: 300
    }
  },
  {
    text: '5”',
    subTitle: '5” Trunks',
    description: '',
    img: {
      url: resizeShopifyImage(
        'https://cdn.shopify.com/s/files/1/0207/9406/files/trunks_five_inches_leg.jpg?v=1698066618',
        { width: '600' }
      ),
      width: 300,
      height: 300
    }
  }
] as const

const SHORTS_LEG_DATA = [
  {
    text: '7”',
    subTitle: '7” Short',
    description: Translations.localise('product.filters.short-7'),
    img: {
      url: '/static/images/compare-modals/Spoke_Web_Shorts_Leg_Lengths_Compare_Sizing_Pop_Up_7inch.jpg',
      width: 300,
      height: 380
    }
  },
  {
    text: '9”',
    subTitle: '9” Short',
    description: Translations.localise('product.filters.short-9'),
    img: {
      url: '/static/images/compare-modals/Spoke_Web_Shorts_Leg_Lengths_Compare_Sizing_Pop_Up_9inch.jpg',
      width: 300,
      height: 380
    }
  },
  {
    text: '11”',
    subTitle: '11” Short',
    description: Translations.localise('product.filters.short-11'),
    img: {
      url: '/static/images/compare-modals/Spoke_Web_Shorts_Leg_Lengths_Compare_Sizing_Pop_Up_11inch.jpg',
      width: 300,
      height: 380
    }
  }
] as const

const SWIMS_LEG_DATA = [
  {
    text: '3”',
    subTitle: '3” Short',
    description: '',
    img: {
      url: 'https://images.ctfassets.net/amhdwl2zsv5z/5N1BAM2Pp6vcho2ZIQYgAe/b5122fcb421eae4830c3c92a67eac6b3/shorts_3.png',
      width: 300,
      height: 380
    }
  },
  {
    text: '5”',
    subTitle: '5” Short',
    description: '',
    img: {
      url: 'https://images.ctfassets.net/amhdwl2zsv5z/7C8BF4qQJqC9nXc8iFNMt6/0a597c40f21dd611ca490823843ec35d/shorts_5.png',
      width: 300,
      height: 380
    }
  },
  {
    text: '7”',
    subTitle: '7” Short',
    description: '',
    img: {
      url: 'https://images.ctfassets.net/amhdwl2zsv5z/2cN9aqyIFfedGpXoLnhhJf/829262076e9db4c50ac0e4145c0dbd36/shorts_7.png',
      width: 300,
      height: 380
    }
  }
] as const

function getLegLengthsData(productType: string) {
  if (productType.includes('Swims')) {
    return SWIMS_LEG_DATA
  }
  if (productType.includes('Shorts')) {
    return SHORTS_LEG_DATA
  }
  if (productType.includes('Trunks')) {
    return TRUNKS_LEG_DATA
  }
}

type LegSubtitleWithModalProps = {
  productType: string
  hasMoreThanOneLegSizeInStock: boolean
  modalOpen: boolean
  toggleModal: () => void
}

function LegSubtitleWithModal({
  productType,
  modalOpen,
  toggleModal,
  hasMoreThanOneLegSizeInStock
}: LegSubtitleWithModalProps) {
  const data = getLegLengthsData(productType)

  if (!data) {
    return null
  }

  return (
    <>
      <div className={styles.subtitle__container}>
        <h2 className={styles.subtitle}>
          Leg <span>(inches)</span>
        </h2>
        {hasMoreThanOneLegSizeInStock && (
          <div className={styles.subtitle}>
            <ButtonMinimal underlined onClick={toggleModal}>
              Compare lengths
            </ButtonMinimal>
          </div>
        )}
      </div>
      {modalOpen && hasMoreThanOneLegSizeInStock && (
        <Modal onClose={toggleModal} openedModal={modalOpen}>
          <Tabs
            data={data}
            byline=""
            title={'Compare lengths'}
            extraClass="compare-lengths"
          />
        </Modal>
      )}
    </>
  )
}

export default LegSubtitleWithModal
